import React from 'react'
import { Flex } from 'components/Layout'
import { InfoCardsWidget } from 'components/Widgets'

export const InfoCards: React.FC<React.PWC<unknown>> = () => (
  <Flex>
    <InfoCardsWidget />
  </Flex>
)
